"use client";

import { useEffect, useState } from "react";
import { resolveV3VideoUrl } from "@/actions/videos";

export function useResolvedVideoUrl(url: string) {
  const [resolvedUrl, setResolvedUrl] = useState(url);
  const [isLoading, setIsLoading] = useState(url?.includes("/v3/") ?? false);

  useEffect(() => {
    if (!url?.includes("/v3/")) {
      setResolvedUrl(url);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    resolveV3VideoUrl(url)
      .then((resolved) => {
        console.log("[useResolvedVideoUrl] resolved:", { from: url, to: resolved });
        setResolvedUrl(resolved);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("[useResolvedVideoUrl] failed:", err);
        setResolvedUrl(url);
        setIsLoading(false);
      });
  }, [url]);

  return { url: resolvedUrl, isLoading };
}
